import React from "react";
import { Link } from "react-router-dom";
import { FaBalanceScale, FaMoneyBillWave, FaUsersCog } from "react-icons/fa";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "bootstrap/dist/css/bootstrap.min.css";

const services = [
  {
    title: " Audit",
    subtitle: "Optimisez votre gestion financière et assurez votre conformité fiscale.",
    icon: <FaBalanceScale />,
    link: "/services/audit",
    backgroundImage: "/assets/images/image7.png",
  },
  {
    title: "Comptabilité - Fiscalité",
    subtitle: "Optimisez votre gestion financière et assurez votre conformité fiscale.",
    icon: <FaBalanceScale />,
    link: "/services/comptabilite-fiscalite",
    backgroundImage: "/assets/images/image7.png",
  },
  {
    title: "Gestion du patrimoine",
    subtitle: "Accompagnement stratégique pour valoriser et protéger votre patrimoine.",
    icon: <FaMoneyBillWave />,
    link: "/services/gestion-patrimoine",
    backgroundImage: "/assets/images/image8.png",
  },
  {
    title: "Paie et gestion des salariés",
    subtitle: "Solutions complètes pour gérer la paie et vos ressources humaines.",
    icon: <FaUsersCog />,
    link: "/services/paie-gestion-salaries",
    backgroundImage: "/assets/images/image9.png",
  },
  
];

const ServiceSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });

  return (
    <section ref={ref} className="service-section">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: -30 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: -30 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        Nos <span className="highlight">Services</span> Clés
      </motion.h2>

      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="col-md-6 col-lg-3"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <Link 
                to={service.link} 
                className="service-card" 
                style={{ backgroundImage: `url(${service.backgroundImage})` }}
              >
                <div className="overlay"></div>
                <div className="darken"></div>

                <div className="content">
                  <div className="icon-container">{service.icon}</div>
                  <h3 className="card-title">{service.title}</h3>
                  <p className="card-subtitle">{service.subtitle}</p> 
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

       
        <motion.div
          className="btn-container"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <Link to="/expertises" className="btn-see-more">
            Voir Plus
          </Link>
        </motion.div>
      </div>

      <style>
        {`
          .service-section {
            padding: 60px 20px;
            text-align: center;
          }

          .section-title {
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 40px;
          }

          .highlight {
            color: #dc3545;
          }

          .service-card {
            position: relative;
            height: 350px;
            border-radius: 0;
            overflow: hidden;
            background-size: cover;
            background-position: center;
            display: flex;
            align-items: flex-end;
            text-align: left;
            padding: 20px;
            text-decoration: none;
            color: white;
            transition: transform 0.3s ease-in-out;
          }

          .service-card:hover {
            transform: scale(1.05);
          }

          .service-card .darken {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
          }

          .service-card .overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 0%;
            background: linear-gradient(to top, rgba(255, 0, 0, 0.4), rgba(0, 255, 0, 0.4));
            transition: height 0.4s ease-in-out;
          }

          .service-card:hover .overlay {
            height: 100%;
          }

          .service-card .content {
            position: relative;
            z-index: 2;
          }

          .icon-container {
            font-size: 48px;
            margin-bottom: 15px;
            color: #ffc107;
          }

          .card-title {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .card-subtitle {
            font-size: 14px;
            margin-top: 5px;
            opacity: 0;
            transform: translateY(10px);
            transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
          }

          .service-card:hover .card-subtitle {
            opacity: 1;
            transform: translateY(0);
          }

          /* Bouton Voir Plus */
          .btn-container {
            text-align: center;
            margin-top: 40px;
          }

          .btn-see-more {
            display: inline-block;
            padding: 12px 25px;
            font-size: 18px;
            font-weight: bold;
            color: white;
            background-color: #dc3545;
            border-radius: 5px;
            text-decoration: none;
            transition: all 0.3s ease-in-out;
          }

          .btn-see-more:hover {
            background-color: #b02a37;
            transform: scale(1.05);
          }

          /* Responsive media queries pour ServiceSection */
          @media (max-width: 1199px) {
            .service-section {
              padding: 50px 15px;
            }
            
            .section-title {
              font-size: 30px;
              margin-bottom: 35px;
            }
            
            .service-card {
              height: 320px;
              margin-bottom: 20px;
            }
            
            .icon-container {
              font-size: 42px;
            }
            
            .card-title {
              font-size: 18px;
            }
          }

          @media (max-width: 991px) {
            .service-section {
              padding: 40px 15px;
            }
            
            .section-title {
              font-size: 28px;
              margin-bottom: 30px;
            }
            
            .service-card {
              height: 300px;
              margin-bottom: 25px;
            }
            
            .icon-container {
              font-size: 40px;
              margin-bottom: 12px;
            }
            
            .card-title {
              font-size: 17px;
            }
            
            .card-subtitle {
              font-size: 13px;
            }
          }

          @media (max-width: 768px) {
            .service-section {
              padding: 35px 10px;
            }
            
            .section-title {
              font-size: 24px;
              margin-bottom: 25px;
            }
            
            .service-card {
              height: 280px;
              margin-bottom: 20px;
              padding: 15px;
            }
            
            .icon-container {
              font-size: 36px;
              margin-bottom: 10px;
            }
            
            .card-title {
              font-size: 16px;
              margin-bottom: 8px;
            }
            
            .card-subtitle {
              font-size: 12px;
              opacity: 1;
              transform: translateY(0);
            }
            
            .btn-see-more {
              padding: 10px 20px;
              font-size: 16px;
            }
            
            .btn-container {
              margin-top: 30px;
            }
          }

          @media (max-width: 576px) {
            .service-section {
              padding: 30px 8px;
            }
            
            .section-title {
              font-size: 22px;
              margin-bottom: 20px;
            }
            
            .service-card {
              height: 250px;
              padding: 12px;
              margin-bottom: 15px;
            }
            
            .icon-container {
              font-size: 32px;
              margin-bottom: 8px;
            }
            
            .card-title {
              font-size: 15px;
              margin-bottom: 6px;
            }
            
            .card-subtitle {
              font-size: 11px;
            }
            
            .btn-see-more {
              padding: 8px 18px;
              font-size: 15px;
            }
          }

          @media (max-width: 400px) {
            .section-title {
              font-size: 20px;
            }
            
            .service-card {
              height: 220px;
              padding: 10px;
            }
            
            .icon-container {
              font-size: 28px;
            }
            
            .card-title {
              font-size: 14px;
            }
            
            .card-subtitle {
              font-size: 10px;
            }
            
            .btn-see-more {
              padding: 7px 15px;
              font-size: 14px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default ServiceSection;
